import url from './url';
import makeClearableUrlPrefix from '../lib/makeClearableUrlPrefix';



export default url(({ urlPrefix = null, source = null, multipleSources = null }) => {
  const prefix = makeClearableUrlPrefix(urlPrefix);

  if (source && multipleSources) {
    return `${prefix}/dictionaries/import/success?source=${source}&multipleSources=${multipleSources}`;
  }

  return source
    ? `${prefix}/dictionaries/import/success?source=${source}`
    : `${prefix}/dictionaries/import/success`;
});
